import React from 'react'
import '../subComponents/Loader.css'

function Loader(props) {
    return (
        <div className={`lds-dual-ring ${props.colored ? 'colored' : ''}`}></div>
    )
}
export default Loader
